export default __webpack_public_path__ + "img/call-me.2c422dae.svg";